<template>
  <v-container
    id="deductionEdit"
    class="pa-0"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <base-resource-select
          label="Product / Carrier"
          item-text="productCarrier"
          item-value="productCarrierKey"
          bind-text="productCarrier"
          bind-value="productCarrierKey"
          :bind-item="editedItem"
          :error-messages="productCarrierError"
          :fetch-method="getFromProductCarrier"
          :disabled="disabled"
          @change="onProductCarrierChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="editedItem.title"
          :error-messages="safeFormErrors.Title"
          :disabled="disabled"
          label="Title"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="editedItem.code"
          :error-messages="safeFormErrors.Code"
          :disabled="disabled"
          label="Code"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-section-dropdown
          :value.sync="editedItem.taxStatus"
          section="OE Deduction - Tax Status"
          :error-messages="safeFormErrors.TaxStatus"
          :disabled="disabled"
          label="Tax Status"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-section-dropdown
          :value.sync="editedItem.status"
          section="OE Deduction - Status"
          :error-messages="safeFormErrors.Status"
          :disabled="disabled"
          label="Status"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'DeductionEdit',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      formErrors: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      editedItem: null,

      productCarrierResource: new TroodyApi('oeeLigibilityProductCarrier/'),
    }),

    computed: {
      safeFormErrors () {
        return this.formErrors || {}
      },

      productCarrierError () {
        let e = null
        if (this.safeFormErrors) {
          e = (this.safeFormErrors.ProductId || this.safeFormErrors.CarrierId)
        }
        return e
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.editedItem = this.value
        const key = this.buildProductCarrierKey()
        if (key) {
          this.editedItem.productCarrierKey = key
        }
      },

      buildProductCarrierKey () {
        let key = null

        if (this.editedItem && this.editedItem.openEnrollmentId && this.editedItem.productId && this.editedItem.carrierId) {
          key = this.editedItem.openEnrollmentId + '_' + this.editedItem.productId + '_' + this.editedItem.carrierId
        }

        return key
      },

      getFromProductCarrier () {
        return this.productCarrierResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      transformItem () {
        this.editedItem.openEnrollmentId = this.openEnrollment.id

        return this.editedItem
      },

      onProductCarrierChange (bindItem, selectedValue) {
        let productId = null
        let carrierId = null

        if (selectedValue) {
          const parts = selectedValue.split('_')
          if (parts.length >= 3) {
            productId = Number(parts[1])
            carrierId = Number(parts[2])
          }
        }

        this.editedItem.productId = productId
        this.editedItem.carrierId = carrierId
        this.onChange()
      },

      onChange () {
        this.transformItem()
        this.$emit('update:value', this.editedItem)
        this.$emit('change', this.editedItem)
      },
    },
  }
</script>
